<page-loader *ngIf="isLoading"></page-loader>
<div class="page-section series-form-page" *ngIf="!isLoading">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" (click)="onCancel()">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item">
					<a [routerLink]="['/admin/user-listing']">Users</a>
				</li>
				<li class="breadcrumbs-list-item app-l-current-page">
					Invite User
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content">
		<h1>Invite User</h1>

		<form [formGroup]="userInviteForm" (ngSubmit)="onSave()">
			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Full Name</label>
					<input class="app-c-form-control" type="text" formControlName="fullName"
						[readonly]="isEditInvite" />
					<div class="error-message" *ngIf="f.fullName.touched && f.fullName.errors?.required">
						Full name is required
					</div>
				</div>

				<div class="app-c-form-group">
					<label class="app-c-form--label">Email</label>
					<input class="app-c-form-control" type="text" formControlName="email"
						[readonly]="isEditInvite" />
					<div class="error-message" *ngIf="f.email.touched && !f.email.valid">
						Invalid email
					</div>
				</div>
			</div>

			<div class="form-row">
				<div class="app-c-form-group">
					<label class="app-c-form--label">Role</label>
					<select class="app-c-form-control" formControlName="roleId"
						(change)="onRoleChange()">
						<option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
					</select>
				</div>

				<div class="app-c-form-group">
					<label class="app-c-form--label">Timezone</label>
					<select class="app-c-form-control" formControlName="timezone">
						<option value="">Select this user's timezone</option>
						<option *ngFor="let timezone of timezones" [value]="timezone.key">
							{{ timezone.text }}
						</option>
					</select>
				</div>
			</div>

			<!-- Organization multi-select -->
			<div class="app-c-form-group">
				<label class="app-c-form--label">Organizations</label>
				<multiselect-autocomplete
					placeholder="Select organization"
					[formControl]="organizationDataForm.controls.orgId"
					[items]="multiSelOrgs"
					[formValue]="organizationDataForm.value.orgId"
					(onSelectItems)="onSelectOrgs($event)">
				</multiselect-autocomplete>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label">Invite Message</label>
				<textarea class="app-c-form-control textarea-control" formControlName="message"
					placeholder="200 character max" maxlength="200"></textarea>
			</div>

			<div class="checkbox-row">
				<label class="checkbox-label">
					<input type="checkbox" formControlName="notificationOn" />
					Receive Notifications
				</label>
			</div>

			<div class="checkbox-row">
				<label class="checkbox-label">
					<input type="checkbox" formControlName="lockedRole" />
					Lock role (useful for SSO)
				</label>
			</div>

			<div class="form-actions">
				<button type="button" class="app-c-btn app-c-btn--secondary app-c-btn--curve"
					(click)="onCancel()">Cancel</button>
				<button type="submit" class="app-c-btn app-c-btn--primary app-c-btn--curve">Send Invite</button>
			</div>
		</form>
	</div>
</div>
